<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-09-19 16:38:54
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-03-25 17:08:01
 * @Description: file content
 -->
<template>
  <div class="register">
    <div class="register-title" v-if="isShowRegTitle">{{registerTitle}}</div>
    <div class="register-title2" v-if="!isShowRegTitle"></div>
    <div class="content-info">
      <div class="info-item border-bottom">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_name.png" alt />
        <span class="start">*</span>
        <input type="text" placeholder="请输入姓名" v-model="name" class="info-input" @blur="blurInput" />
      </div>
      <div class="info-item border-bottom" v-if="isShowIdCard">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_idcard.png" alt />
        <span class="start">*</span>
        <input
          type="text"
          placeholder="请输入身份证"
          v-model="idcard"
          class="info-input"
          @blur="blurInput"
        />
      </div>
      <div class="info-item border-bottom">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_phone.png" alt />
        <span class="start">*</span>
        <input
          type="tel"
          placeholder="请输入手机号"
          v-model="mobile"
          class="info-input"
          @blur="blurInput"
        />
      </div>
      <div class="info-item border-bottom">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_vcode.png" alt />
        <span class="start">*</span>
        <input
          type="number"
          placeholder="输入验证码"
          v-model="vcode"
          oninput="if(value.length>6)value=value.slice(0,6)"
          @blur="blurInput"
          style="width:40%"
        />
        <span v-show="!showVcode" @click="getVcode" class="getvcode" style="width:40%">{{getVcodes}}</span>
        <span v-show="showVcode" class="getvcode" style="width:40%">{{counts}}s</span>
      </div>
      <!-- 来源类型 -->
      <div class="info-items border-bottom">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_source.png" alt />
        <span class="start">*</span>
        <multiselect
          v-model="source"
          :options="options"
          :custom-label="nameWithLang"
          placeholder="请选择或快速搜索"
          label="itemtext"
          track-by="itemtext"
          :show-labels="false"
          :allow-empty="false"
          deselect-label
        ></multiselect>
      </div>

      <div class="info-item border-bottom" v-if="showRecommendUserName">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_name.png" alt />
        <span class="start"></span>
        <input
          type="text"
          placeholder
          v-model="recommendUserName"
          class="info-input"
          disabled="true"
          @blur="blurInput"
          style="background: transparent;"
        />
      </div>

      <!-- 推荐人手机号码 -->
      <div class="info-item border-bottom" v-if="showRecommendUserMobile">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_phone.png" alt />
        <span class="start"></span>
        <input
          type="tel"
          placeholder="请输入推荐人手机号"
          v-model="recommendUserMobile"
          class="info-input"
          @blur="blurInput"
        />
      </div>

      <!-- 团队公司 中介公司 -->
      <div class="info-items border-bottom" v-if="!isshow&&!iscompany&&!isWdzyt">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_team.png" alt />
        <span class="start">*</span>
        <multiselect
          v-model="company"
          :options="coptions"
          :custom-label="cOptions"
          placeholder="请选择公司或搜索"
          label="agencyname"
          track-by="agencyname"
          :show-labels="false"
          :allow-empty="false"
          deselect-label
        ></multiselect>
      </div>
      <!-- 意向项目 -->
      <div class="info-items border-bottom" v-if="!isshow&&isprojecshow&&!isWdzyt">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_project.png" alt />
        <span class="start">*</span>
        <multiselect
          v-model="project"
          :options="poptions"
          :custom-label="pOptions"
          placeholder="请选择或快速搜索"
          label="projectname"
          track-by="projectname"
          :show-labels="false"
          :allow-empty="false"
          deselect-label
        ></multiselect>
      </div>
      <!-- 武地置业通  地产集团员工子公司-->
      <div class="info-items border-bottom" v-if="isShowWdzytSource1Sub">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_team.png" alt />
        <span class="start">*</span>
        <multiselect
          v-model="wdzytSource1SubValue"
          :options="wdzytSource1SubList"
          placeholder="请选择子公司"
          label="name"
          track-by="name"
          :show-labels="false"
          :allow-empty="false"
          deselect-label
        ></multiselect>
      </div>
      <!-- 武地置业通  合作单位值-->
      <div class="info-item border-bottom" v-if="isShowWdzytSource2Sub">
        <img src="http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_team.png" alt />
        <span class="start">*</span>
        <input
          type="text"
          placeholder="请输入合作单位名称"
          v-model="wdzytSource2SubValue"
          class="info-input"
          @blur="blurInput"
        />
      </div>
      <div class="agreement" v-if="isShowAgreementBtn">
        <mt-checklist title v-model="checkedAgreement" :options="['请阅读和同意用户注册协议']"></mt-checklist>
        <div class="div1" @click="clickAgreement">《用户注册协议》</div>
      </div>
      <div class="submit" @click="submit">确认提交</div>
    </div>
    <reghragreement v-if="isShowAgreement" v-on:close="closeAgreement"></reghragreement>
  </div>
</template>
<script>
import utils from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { MessageBox, Checklist } from "mint-ui";
import request from "@/utils/request";
// import * as vali from "@/utils/validate";
import Cookies from "js-cookie";
// import * as config from "./config";
import Multiselect from "vue-multiselect";
import reghragreement from "./reg-hr-agreement";
import { mapState, mapMutations } from "vuex";
let that105 = null;
export default {
  components: {
    Multiselect,
    reghragreement
  },
  props: {},
  computed: {
    ...mapState(["receiveSpreadInfo"])
  },
  data() {
    return {
      registerTitle: "",
      isshow: false,
      isprojecshow: false,
      isShowIdCard: false,
      iscompany: false,
      isHenduoke: true,
      ismore: false,
      name: "",
      recommendUserName: "",
      showRecommendUserName: false,
      recommendUserMobile: "", //推荐号码
      showRecommendUserMobile: false,
      idcard: "",
      mobile: "",
      sourceid: "", //来源类型 id
      channel: "", //来源类型 文本
      companyid: "", //团队公司
      projectid: "", //意向项目
      authtype: "",
      vcode: "",
      showVcode: false,
      counts: "",
      timer: null,
      getVcodes: "获取验证码",
      address: "",
      personalprofile: "",
      //来源类型
      source: { itemtext: "来源类型", id: 0 },
      options: [
        // { itemtext: '上海', id:'1' },
        // { itemtext: '1', id:'2' },
        // { itemtext: '2', id:'3' },
        // { itemtext: '3',  id:'4'},
      ],
      //团队公司
      company: { agencyname: "中介公司", id: 0 },
      coptions: [],
      //意向项目
      project: { projectname: "意向项目", id: 0 },
      poptions: [],
      openid: Cookies.get("openid"),
      //   action: ((Cookies.get('appid') || Cookies.get('appid') == 'wx57e1c13d2f1ecff0' || Cookies.get('appid') == 'wx2c3d601bd568614b') ? '/global/Select/listItemFromCache' : 'getimpldataitemcache'),
      action: "getimpldataitemcache", //这个接口可有可无
      isWdzyt: false,
      isShowWdzytSource1Sub: false, // 武地置业通，是否显示地产集团员工子公司
      wdzytSource1SubValue: "", // 武地置业通，地产集团员工子公司值
      wdzytSource1SubList: [
        { name: "集团总部" },
        { name: "控股公司（统建公司城开公司）" },
        { name: "武汉市保障性住房投资建设公司" },
        { name: "武汉地铁地产联合置业公司" },
        { name: "武汉地产集团市政建设管理公司" },
        { name: "公建事业部" },
        { name: "城发投公司（城发土地分中心）" },
        { name: "武汉琴台资产经营管理公司" },
        { name: "武汉城发投资基金管理公司" },
        { name: "武汉时代建筑设计公司" },
        { name: "武汉建开工程总承包公司" },
        { name: "武汉鸿诚咨询管理公司" },
        { name: "武汉地产集团东方物业管理公司" },
        { name: "新兴建材公司（绿缘材料公司）" },
        { name: "武汉城星联合科技发展公司" },
        { name: "武汉文化创意产业投资发展公司" },
        { name: "云端武汉互联网产业投资发展公司" },
        { name: "武汉市人防工程专用设备公司" }
      ], // 武地置业通，地产集团员工子公司列表
      isShowWdzytSource2Sub: false, // 武地置业通，是否显示合作单位输入框
      wdzytSource2SubValue: "", // 武地置业通，是否显示合作单位值
      checkedAgreement: [], //勾选协议
      isShowAgreement: false,
      isShowRegTitle: true, //是否显示首页
      isShowAgreementBtn: false //是否显示注册协议按钮
    };
  },
  watch: {
    source: {
      handler(val) {
        console.log(val);
        if (!val) return;
        this.channel = val.itemtext;
        this.sourceid = val.id;
        if (this.global.SUBDOMAIN == "wdzyt" && this.sourceid == 1) {
          this.isShowWdzytSource2Sub = false;
          this.wdzytSource2SubValue = "";
          this.isShowWdzytSource1Sub = true;
        } else if (this.global.SUBDOMAIN == "wdzyt" && this.sourceid == 2) {
          this.isShowWdzytSource1Sub = false;
          this.wdzytSource1SubValue = "";
          this.isShowWdzytSource2Sub = true;
        } else if (this.global.SUBDOMAIN == "wdzyt") {
          this.isShowWdzytSource1Sub = false;
          this.wdzytSource1SubValue = "";
          this.isShowWdzytSource2Sub = false;
          this.wdzytSource2SubValue = "";
        } else if (this.global.SUBDOMAIN == "rywlkj" && this.sourceid == 2) {
          this.isshow = false;
          this.isprojecshow = false;
          this.iscompany = false;
          this.project = { projectname: "意向项目", id: 0 };
        } else {
          // 默认
          if (this.sourceid == 1) {
            //泛经纪人 只显示来源类型
            this.isshow = true;
            this.isprojecshow = false;
            this.project = { projectname: "意向项目", id: 0 };
          }
          if (this.sourceid == 2) {
            //职业经纪人 都显示 来源类型，团队公司 ， 意向项目
            this.isshow = false;
            this.isprojecshow = true;
            this.iscompany = false;
            this.project = { projectname: "意向项目", id: 0 };
          }
          if (this.sourceid == 3) {
            //老业主 显示来源类型 和 已购项目 也就是意向项目
            this.isshow = false;
            this.isprojecshow = true;
            this.iscompany = true;
            this.project = { projectname: "已购项目", id: 0 };
          }
          if (this.sourceid == 1076) {
            //员工 只显示来源类型
            this.isshow = true;
            this.isprojecshow = false;
            this.iscompany = true;
            this.project = { projectname: "意向项目", id: 0 };
          }
        }

        if (this.sourceid == 1 || this.sourceid == 2) {
          if (this.global.SUBDOMAIN != "wdzyt") {
            if (this.recommendUserName) {
              this.showRecommendUserName = true;
            } else {
              this.showRecommendUserMobile = true;
            }
          }
        } else {
          this.showRecommendUserMobile = false;
          this.showRecommendUserName = false;
        }
      }
    },
    company: {
      handler(val) {
        // console.log(val.id)
        this.companyid = val.id;
      }
    },
    project: {
      handler(val) {
        // console.log(val.id)
        this.projectid = val.id;
      }
    },
    vcode(v, o) {
      Cookies.remove("vericode");
      Cookies.set("vericode", v);
    }
  },
  methods: {
    closeAgreement() {
      this.isShowAgreement = false;
    },
    clickAgreement() {
      this.isShowAgreement = true;
    },
    //权限判断
    checkApplyStatus() {
      let _self = this;
      request
        .get(_self.global.API_URL, {
          action: "dhyxcrm",
          requestParam: {
            module: "yx",
            oper: "getAgentInfo"
          }
        })
        .then(response => {
          if (response.code == 1) {
            // popMessage();
          } else if (response.code == 3 || response.code == 2) {
            // openUrl('./market-all-hr.html');
          } else {
            _self.initData();
          }
        });
    },
    initData() {
      // if(utils.checkIsHuafa()) {
      //   this.company = { agencyname: "中介公司", id: 0 }
      //   // this.options = [{ itemtext: "泛经纪人", id: 1 }];
      //   // this.source = { itemtext: "泛经纪人", id: 1 }
      //   // this.sourceid = 1
      //   this.options = [{ itemtext: "员工", id: 1076 }];
      //   this.source = { itemtext: "员工", id: 1076 }
      //   this.sourceid = 1076
      // } else {
      this.company = { agencyname: "项目", id: 0 };
      switch (this.global.SUBDOMAIN) {
        case "lzlc":
          this.options = [{ itemtext: "泛经纪人", id: 1 }];
          this.source = { itemtext: "泛经纪人", id: 1 };
          this.sourceid = 1;
          if (this.recommendUserName) {
            this.showRecommendUserName = true;
          } else {
            this.showRecommendUserMobile = true;
          }
          break;
        case "rywlkj":
          this.options = [
            // { itemtext: "泛经纪人", id: 1 },
            { itemtext: "职业经纪人", id: 2 }
          ];
          this.source = { itemtext: "职业经纪人", id: 2 };
          this.sourceid = 2;
          if (this.recommendUserName) {
            this.showRecommendUserName = true;
          } else {
            this.showRecommendUserMobile = true;
          }
          break;
        case "wdzyt":
          this.isWdzyt = true;
          this.options = [
            { itemtext: "地产集团员工", id: 1 },
            { itemtext: "合作单位员工", id: 2 },
            { itemtext: "地产集团业主", id: 3 },
            { itemtext: "一般推荐人", id: 4 },
            { itemtext: "拓客团队", id: 5 },
            { itemtext: "机构", id: 6 }
          ];
          this.source = { itemtext: "地产集团员工", id: 1 };
          this.sourceid = 1;
          break;
        case "shlfsj":
          this.options = [
            { itemtext: "学生/家长", id: 1 },
            { itemtext: "合作校企", id: 2 },
            { itemtext: "毕业校友", id: 3 },
            { itemtext: "在校老师", id: 1076 },
          ];
          this.source = { itemtext: "学生/家长", id: 1 };
          this.sourceid = 1;
          break;
        default:
          this.options = [
            { itemtext: "泛经纪人", id: 1 },
            { itemtext: "职业经纪人", id: 2 },
            { itemtext: "老业主", id: 3 },
            { itemtext: "员工", id: 1076 }
          ];
          this.source = { itemtext: "泛经纪人", id: 1 };
          this.sourceid = 1;
          console.log("bbbbbbbbb");
          if (this.recommendUserName) {
            this.showRecommendUserName = true;
          } else {
            this.showRecommendUserMobile = true;
          }
          break;
        // }
      }
    },
    //来源类型
    nameWithLang({ itemtext, id }) {
      return `${itemtext}`;
    },
    //中介公司
    cOptions({ agencyname, id }) {
      return `${agencyname}`;
    },
    //意向项目
    pOptions({ projectname, id }) {
      return `${projectname}`;
    },
    // 获取更多
    getmore() {
      this.ismore = true;
    },
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      that105.temporaryRepair();
    },
    //获取手机验证码/activity/logic/takeMobileVerifyCode
    getActPhoneVCode() {
      const _self = this;
      if (!_self.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        request
          .get(_self.global.API_URL, {
            action: "getVericode",
            requestParam: {
              mobile: _self.mobile
            }
          })
          .then(response => {
            if (response.code == 0) {
              MessageBox.alert(
                "验证码已通过短信发送到您的手机，稍等一会儿哦",
                "提示"
              );
            }
          });
      }
    },
    //获取验证码
    getVcode() {
      const _self = this;
      const TIME_COUNT = 60;
      _self.getActPhoneVCode();
      if (!_self.timer && _self.mobile) {
        _self.counts = TIME_COUNT;
        _self.showVcode = true;
        _self.timer = setInterval(() => {
          if (_self.counts > 0 && _self.counts <= TIME_COUNT) {
            _self.counts--;
          } else {
            _self.showVcode = false;
            _self.getVcodes = "重新获取";
            clearInterval(_self.timer);
            _self.timer = null;
          }
        }, 1000);
      }
    },
    //提交信息
    submit() {
      let _self = this;
      console.log("=======>", this.wdzytSource1SubValue);

      if (!_self.name || !_self.mobile || !_self.sourceid) {
        return MessageBox.alert("所有带 * 项均为必填项", "提示");
      }
      if (!_self.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        if (!utils.isMobile(_self.mobile)) {
          return MessageBox.alert("请填写正确的手机号", "提示");
        }
      }
      if (!_self.vcode) {
        return MessageBox.alert("请输入验证码", "提示");
      }
      if (_self.isShowIdCard) {
        if (!_self.idcard) {
          return MessageBox.alert("请输入身份证号码", "提示");
        } else if (
          !/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(_self.idcard)
        ) {
          return MessageBox.alert("您身份证号码格式不正确", "提示");
        }
      }
      if (!_self.channel) {
        return MessageBox.alert("请选择来源类型", "提示");
      }
      // 姓名、手机号、验证码之后要验证的表单
      if (_self.global.SUBDOMAIN == "wdzyt" && _self.sourceid == 1) {
        if (!_self.wdzytSource1SubValue) {
          return MessageBox.alert("请选择子公司", "提示");
        }
      } else if (_self.global.SUBDOMAIN == "wdzyt" && _self.sourceid == 2) {
        if (!_self.wdzytSource2SubValue) {
          return MessageBox.alert("请输入单位名称", "提示");
        }
      } else if (_self.global.SUBDOMAIN == "wdzyt") {
        if (_self.checkedAgreement.length == 0) {
          return MessageBox.alert("请先同意《用户注册协议》", "提示");
        }
      } else if (_self.global.SUBDOMAIN == "rywlkj" && _self.sourceid == 2) {
        if (!_self.companyid) {
          return MessageBox.alert("请选择团队公司", "提示");
        }
      } else if (_self.sourceid == 2) {
        //   companyid: '', //团队公司
        //   projectid: '', //意向项目
        if (!_self.companyid) {
          return MessageBox.alert("请选择团队公司", "提示");
        }
        if (!_self.projectid) {
          return MessageBox.alert("请选择意向项目", "提示");
        }
      } else if (_self.sourceid == 3) {
        if (!_self.projectid) {
          return MessageBox.alert("请选择已购项目", "提示");
        }
      }

      if (_self.recommendUserMobile) {
        if (!utils.isMobile(_self.recommendUserMobile)) {
          return MessageBox.alert("请填写正确的推荐人手机号", "提示");
        }
      }

      Cookies.set("vericode", _self.vcode);

      let parames = {
        module: "yx",
        oper: "apply",
        agentname: _self.name,
        mobile: _self.mobile,
        recommendUserMobile: _self.recommendUserMobile,
        channel: _self.channel //来源
      };
      if (_self.isShowIdCard) {
        parames.idcard = _self.idcard;
      }

      if (_self.global.SUBDOMAIN == "wdzyt") {
        if (
          (_self.wdzytSource1SubValue && _self.wdzytSource1SubValue.name) ||
          _self.wdzytSource2SubValue
        ) {
          _self.updateMyFans({
            openid: Cookies.get("openid"),
            name: _self.name,
            mobile: _self.mobile,
            company:
              _self.wdzytSource1SubValue.name || _self.wdzytSource2SubValue
          });
        }
        parames.authtype = 1; //默认为泛经纪人
      } else {
        if (_self.sourceid == 1) {
          parames.authtype = _self.sourceid; //泛经济人
        } else if (_self.sourceid == 2) {
          parames.authtype = _self.sourceid;
          parames.agencyid = _self.companyid;
          parames.projectid = _self.projectid;
        } else if (_self.sourceid == 3) {
          parames.authtype = _self.sourceid;
          parames.projectid = _self.projectid;
        } else {
          parames.authtype = 4; //员工
        }
      }
      request
        .get(_self.global.API_URL, {
          action: "dhyxcrm",
          requestParam: parames
        })
        .then(response => {
          if (response.code == 0) {
            if (_self.$ismp) {
              MessageBox.alert("提交成功！", "提示").then(function() {
                utils.mp.switch("/pages/rs/index/index");
              });
            } else {
              MessageBox.alert("提交成功！", "提示").then(function() {
                _self.$emit("afterRegisterHr");
              });
            }
          } else {
            MessageBox.alert("注册失败！", "提示").then(function() {});
          }
        });
    },
    updateMyFans(postObj) {
      let _self = this;
      request
        .get(_self.global.API_URL, {
          action: "/hb/HbUserAction/updateMyFans",
          requestParam: {
            obj: postObj
          }
        })
        .then(response => {});
    },

    //中介公司
    companylist() {
      let _self = this;
      request
        .get(_self.global.API_URL, {
          action: "dhyxcrm",
          requestParam: {
            module: "agency",
            oper: "list"
          }
        })
        .then(response => {
          if (response.obj && response.obj.total > 0) {
            _self.coptions = response.obj.list;
          }
        });
    },
    //意向项目
    projectlist() {
      let _self = this;
      request
        .get(_self.global.API_URL, {
          action: "dhyxcrm",
          requestParam: {
            module: "project",
            oper: "list"
          }
        })
        .then(response => {
          if (response.obj && response.obj.total > 0) {
            _self.poptions = response.obj.list;
          }
        });
    },
    init() {
      let _self = this;
      _self.companylist();
      _self.projectlist();

      if (_self.global.SUBDOMAIN == "wdzyt") {
        _self.isShowRegTitle = false;
        _self.isShowAgreementBtn = true;
      }
      if (
        location.host.indexOf("xjzcfd.") > -1 ||
        location.host.indexOf("lzlc.") > -1 ||
        (location.host.indexOf("localhost") > -1 && false)
      ) {
        _self.isShowIdCard = true;
      }
      if (location.host.indexOf("henduoke.") > -1) {
        _self.isHenduoke = true;
      }
      if (location.host.indexOf("hllsq.") > -1) {
        _self.registerTitle = "注册全民经纪人";
      } else {
        _self.registerTitle = "完成注册获得更多功能";
      }
      _self.checkApplyStatus();
    }
  },
  created() {
    that105 = this;
    this.init();
    utils.checkMapStateCallback(this, ["receiveSpreadInfo"]).then(() => {
      if (this.receiveSpreadInfo.refereeopenid) {
        //判断上级传播者的状态
        comreq.getUserInfo2(this.receiveSpreadInfo.refereeopenid).then(res => {
          if (res.agentopenid || res.saleropenid) {
            this.recommendUserName = "推荐人：" + res.name;
            this.recommendUserMobile = res.mobile;
            this.showRecommendUserName = true;
            this.showRecommendUserMobile = false;
          }
        });
      }
    });
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="stylus" scoped>
.register {
  width: 100%;
  background: #fff;
}

.register .register-title {
  width: 100%;
  text-align: center;
  font-size: 0.35rem;
  color: #333;
  line-height: 1.2rem;
  height: 1.2rem;
}

.register-title2 {
  height: 20px;
}

.register .content-info {
  width: 90%;
  margin: 0 auto;
}

.register .content-info .info-item {
  width: 100%;
  height: 0.88rem;
  line-height: 0.88rem;
  display: flex;
}

.register .content-info .info-item>img {
  width: 0.4rem;
  height: 0.4rem;
  padding: 0.24rem 0.24rem;
  display: block;
}

.register .content-info .info-item .start {
  display: block;
  width: 10px;
  height: 0.88rem;
  line-height: 1rem;
  color: #ff775e;
}

.register .content-info .info-items {
  width: 100%;
  display: flex;
}

.register .content-info .info-items>img {
  width: 0.4rem;
  height: 0.4rem;
  padding: 0.24rem 0.24rem;
  display: block;
}

.register .content-info .info-items .start {
  display: block;
  width: 10px;
  height: 1rem;
  line-height: 0.88rem;
  color: #ff775e;
}

.register .content-info .info-item .info-input {
  flex: 1;
}

.multiselect {
  font-size: 0.28rem;
}

.register >>> .multiselect__tags {
  font-size: 0.28rem;
  border: none !important;
  padding: 14px 40px 0 0px;
}

.register >>> .multiselect__input {
  font-size: 0.28rem;
  color: #999;
}

.register >>> .multiselect__single {
  font-size: 0.28rem;
  color: #999;
  padding-left: 0;
}

.vcode {
  margin: 0.2rem auto;
  height: 0.88rem;
  width: 70%;
  border: 1px solid #157F89;
  border-radius: 0.1rem;
  background: #fff;
}

.vcode>input {
  width: 50%;
}

.getvcode {
  display: inline-table;
  line-height: 0.6rem;
  width: 40%;
  font-size: 0.24rem;
  margin: 0.1rem 0;
  height: 0.6rem;
  color: #fff;
  background: #fdb328;
  text-align: center;
  border-radius: 0.1rem;
}

.getMore {
  width: 100%;
  position: relative;
  height: 1.2rem;
  margin-top: 0.5rem;
}

.getMore>img {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -0.36rem;
  animation: mymove 2s infinite;
  width: 0.72rem;
  height: 0.4rem;
}

@keyframes mymove {
  from {
    top: -20px;
    transform: scale(0.6);
  }

  to {
    top: 5px;
    transform: scale(0.9);
  }
}

.getMore>p {
  width: 100%;
  height: 0.4rem;
  line-height: 1.2rem;
  text-align: center;
  font-size: 0.24rem;
  color: #999;
}

.personal {
  width: 100%;
}

.personal>span {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  color: #999;
}

.personal .personal-text {
  width: 100%;
  line-height: 0.6rem;
  height: 2.5rem;
  font-size: 0.28rem;
  background: #ebebeb;
  border-radius: 0.05rem;
}

.upwxcard {
  width: 100%;
}

.upwxcard>span {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  color: #999;
}

.upwxcard .upimg {
  width: 100%;
  height: 2rem;
  background-color: #999;
  background: url('http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_upimg.png') no-repeat; // rs.static.quanc.com.cn/yq-rs-wx/register/icon_upimg.png) no-repeat;
  background-size: 2rem 2rem;
  position: relative;
}

.upwxcard .upimg>img {
  width: 2rem;
  height: 2rem;
}

.agreement .div1 {
  width: 100%;
  padding-left: 50px;
  margin-top: 30px;
  text-decoration: underline;
}

.submit {
  width: 70%;
  margin: 1rem auto;
  height: 0.8rem;
  background: #fdb328;
  color: #fff;
  font-size: 0.28rem;
  line-height: 0.8rem;
  text-align: center;
  border-radius: 0.1rem;
}
</style>


